import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import BreadCrumb from '../../../../core/layout/Breadcrumb';
import Card from '../../../../core/layout/Card';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Separator from '../../../../core/layout/Separator';
import PartnerAccessFrequencyCompanyGaugeContainer from './partner/PartnerAccessFrequencyCompanyGaugeContainer';
import StudentAccessFrequencyCompanyGaugeContainer from './student/StudentAccessFrequencyCompanyGaugeContainer';
import StudentChurnCompanyGaugeContainer from './student/StudentChurnCompanyGaugeContainer';
import StudentEngagementCompanyGaugeContainer from './student/StudentEngagementCompanyGaugeContainer';
import StudentStudyQualityCompanyGaugeContainer from './student/StudentStudyQualityCompanyGaugeContainer';
import PartnerLicensePackageUsageRateCompanyGaugeContainer from './partner/PartnerLicensePackageUsageRateCompanyGaugeContainer';
import PartnerStudentVariationCompanyGaugeContainer from './partner/PartnerStudentVariationCompanyGaugeContainer';
import CustomerSuccessHistoryDialogContainer from './CustomerSuccessHistoryDialogContainer';
import CustomerSuccessSummary from './CustomerSuccessSummary';
import Button from '../../../../core/form/Button';
import { browserHistory } from 'react-router';
import KpiReferenceMonth from '../../commons/KpiReferenceMonth';

const CustomerSuccessCompanyDetailScene = (props) => {
  const typeName = get(props.segment, 'name') || get(props.distributor, 'name', '--');

  return (
    <div>
      <BreadCrumb
        fetching={props.isLoading}
        crumbs={[
          {
            text: "KPI's Customer Success",
            link: `/kpis/customer-success`,
          },
          {
            text: typeName,
            link: `/kpis/customer-success/${props.type}/${props.typeId}/details`,
          },
          {
            text: get(props.company, 'name', 'N/A'),
            link: `/kpis/customer-success/${props.type}/${props.typeId}/company/${props.companyIdId}/details`,
          },
        ]}
      />
      <Card actions={<Button icon="arrow-left" label="back" onClick={() => browserHistory.goBack()} />}>
        <KpiReferenceMonth />
      </Card>
      <Separator />
      <Card title={`Summary - ${typeName}`}>
        <CustomerSuccessSummary type={props.type} typeId={props.typeId} />
      </Card>
      <Separator />
      <Card title="Partner">
        <Row>
          <Column size={4}>
            <PartnerAccessFrequencyCompanyGaugeContainer companyId={props.companyId} />
          </Column>
          <Column size={4}>
            <PartnerLicensePackageUsageRateCompanyGaugeContainer companyId={props.companyId} />
          </Column>
          <Column size={4}>
            <PartnerStudentVariationCompanyGaugeContainer companyId={props.companyId} />
          </Column>
        </Row>
      </Card>
      <Separator />
      <Card title="Students">
        <Row>
          <Column size={3}>
            <StudentAccessFrequencyCompanyGaugeContainer companyId={props.companyId} />
          </Column>
          <Column size={3}>
            <StudentEngagementCompanyGaugeContainer companyId={props.companyId} />
          </Column>
          <Column size={3}>
            <StudentChurnCompanyGaugeContainer companyId={props.companyId} />
          </Column>
          <Column size={3}>
            <StudentStudyQualityCompanyGaugeContainer companyId={props.companyId} />
          </Column>
        </Row>
      </Card>
      <CustomerSuccessHistoryDialogContainer />
    </div>
  );
};

CustomerSuccessCompanyDetailScene.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  segment: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  distributor: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
};

export default CustomerSuccessCompanyDetailScene;
